import { render, staticRenderFns } from "./Bureau.vue?vue&type=template&id=5ba8cbb9"
import script from "./Bureau.vue?vue&type=script&lang=js"
export * from "./Bureau.vue?vue&type=script&lang=js"
import style0 from "./Bureau.vue?vue&type=style&index=0&id=5ba8cbb9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports